"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.taskMerger = void 0;
var merge_mapper_1 = require("../../Data/merge-mapper");
function mergeTaskIntoExisting(tasksStore, task) {
    var way_points = task.way_points;
    if (way_points) {
        way_points.sort(function (wp1, wp2) { return wp1.position - wp2.position; });
    }
    return merge_mapper_1.mergeMapper.mergeIntoExisting(tasksStore, task);
}
exports.taskMerger = { mergeTaskIntoExisting: mergeTaskIntoExisting };
//# sourceMappingURL=task-merger.js.map